import { useTranslation } from 'react-i18next'

import { Chip, ProductPicker, Text } from '@reveni-io/reveni-ui'
import { Divider } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const VariantSkuFilter = ({
  variants,
  handleSearchVariants,
  handleSelectVariant,
  handleDeleteVariant,
  gettingVariants,
  variantsSkusSelected,
}) => {
  const { t } = useTranslation()
  return (
    <>
      <ProductPicker
        products={variants}
        onSearch={handleSearchVariants}
        onSelectProduct={handleSelectVariant}
        loading={gettingVariants}
        placeholder={t('SKU del producto')}
        options={{
          showStoreLink: false,
          showSku: true,
        }}
      />
      <Divider />
      <Styles.SelectedSkus>
        <Text type="bodyMBold">
          {variantsSkusSelected?.length} {t('SKUs seleccionados')}:
        </Text>
        <Styles.SkuContainer>
          {variantsSkusSelected?.map((sku, index) => (
            <Chip key={index} label={sku} onDelete={() => handleDeleteVariant(sku)} />
          ))}
        </Styles.SkuContainer>
      </Styles.SelectedSkus>
    </>
  )
}

export default VariantSkuFilter
